import { TTimeLineAttribute } from "../../types";
import { EnvirotainerTimeLineIcons } from "../../models/Envirotainer/EnvirotainerConfig";
import { defaultTimelineIcons } from "../../utils";

export class TimeLineConfig {
	private readonly timeLineConfig: TTimeLineAttribute;

	public constructor(config: {origin: string; destination: string; isShowEmptyMilestones: boolean}, company: string) {
		this.timeLineConfig = {
			origin: config.origin,
			destination: config.destination,
			icons: company.toUpperCase() === "ENVIROTAINER" ? EnvirotainerTimeLineIcons : defaultTimelineIcons,
			isShowEmptyMilestones: config.isShowEmptyMilestones || false,
		};
	}

	public getTimeLineConfig(): TTimeLineAttribute {
		return this.timeLineConfig;
	}
}
